/// <amd-module name="Wit/UI/Components/WorkItemSmallView/WorkItemSmallView" />
import * as React from "react";
import { Link } from "VSSUI/Link";
import { Tooltip } from "VSSUI/TooltipEx";
import { css } from "VSSUI/Util";
import { CoreFieldRefNames } from "Wit/Common/Generated/Constants";
import { WorkItemTypeIconProvider } from "Wit/UI/Data";
import { WorkItemTypeIcon } from "Wit/UI/WorkItemTypeIcon";
import { IWorkItemSmallViewProps } from "./WorkItemSmallView.Props";

export class WorkItemSmallView extends React.Component<IWorkItemSmallViewProps> {
    constructor(props: IWorkItemSmallViewProps) {
        super(props);
    }

    public render(): JSX.Element | null {
        const { data, dataProvider, className, showId, showTitleLink } = this.props;
        if (!data || !data.fields) {
            // Render nothing if work item data is not provided.
            return null;
        }

        const workItemId = data.id;
        const workItemTitle = data.fields[CoreFieldRefNames.Title];
        const workItemUrl = data._links && data._links.html && data._links.html.href;
        const baseClassNames = "wit-ui-control work-item-small-view";

        return (
            <div className={css(baseClassNames, className)}>
                {dataProvider && (
                    <div className="type-icon-container">
                        <WorkItemTypeIconProvider dataProvider={dataProvider} dataSource={data}>
                            {icon => <WorkItemTypeIcon data={icon} />}
                        </WorkItemTypeIconProvider>
                    </div>
                )}
                {showId && <span className="work-item-id">{workItemId}</span>}
                {showTitleLink && workItemUrl ? (
                    <div className="title-link">
                        <Tooltip text={workItemTitle} overflowOnly={true}>
                            <Link href={workItemUrl} onClick={this._onLinkClick} removeUnderline={true}>
                                {workItemTitle}
                            </Link>
                        </Tooltip>
                    </div>
                ) : (
                    <div className="title-text">
                        <Tooltip text={workItemTitle} overflowOnly={true}>
                            <span>{workItemTitle}</span>
                        </Tooltip>
                    </div>
                )}
            </div>
        );
    }

    private _onLinkClick = (e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
        let preventDefault = false;
        if (this.props.onTitleLinkClick) {
            preventDefault = this.props.onTitleLinkClick(e, this.props.data);
        }
        if (preventDefault) {
            e.preventDefault();
        }
    };
}
